import { render, staticRenderFns } from "./beforetime.vue?vue&type=template&id=61c43497&scoped=true"
import script from "./beforetime.vue?vue&type=script&lang=js"
export * from "./beforetime.vue?vue&type=script&lang=js"
import style0 from "./beforetime.vue?vue&type=style&index=0&id=61c43497&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c43497",
  null
  
)

export default component.exports